// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3DOfg","title":"styles_title__32pI5"};